import {
  FileCategoryOptions,
  SURVEY_MARK_MARK_TYPES,
  SurveyMarkMarkTypes,
} from '@core/api/angular';
import { isNil } from '@lassi/util';

export function formatFileCategories(categories: Array<FileCategoryOptions>) {
  return categories.map((category) => {
    const fileTypeList = category.file_type?.split(',') ?? [];
    const fileTypes =
      fileTypeList.length > 1
        ? fileTypeList.slice(0, -1).join(', ') +
          ' and ' +
          fileTypeList[fileTypeList.length - 1] +
          ' formats'
        : fileTypeList[0] + ' format';
    return `${category.category}: ${category.hint_text ?? fileTypes.toLowerCase()}`;
  });
}

export function fileCategoryAcceptedFileTypes(
  categories: Array<FileCategoryOptions>,
  selectedCategory: string,
): string {
  const category = categories.find((c) => c.category === selectedCategory);
  return category?.file_type
    ? category.file_type
        .split(',')
        .map((fileType) => '.' + fileType)
        .join(',')
    : '';
}

export function markTypeDisplayName(markType: SurveyMarkMarkTypes) {
  switch (markType) {
    case SurveyMarkMarkTypes.PLAQUE:
      return 'Plaque';
    case SurveyMarkMarkTypes.DEEP:
      return 'Deep Driven Rod';
    case SurveyMarkMarkTypes.CROSS:
      return 'Cross Head Nail';
    case SurveyMarkMarkTypes.STAR:
      return 'Star Picket';
    case SurveyMarkMarkTypes.PIPE:
      return 'Pipe';
    case SurveyMarkMarkTypes.RIVET:
      return 'Rivet';
    case SurveyMarkMarkTypes.OTHER:
      return 'Other';
    default:
      return null;
  }
}

export function isStandardPMMarkByNineFig(
  nineFig?: string | number | null,
): boolean {
  if (isNil(nineFig)) {
    return false;
  }

  const nineFigStr = String(nineFig);
  if (nineFigStr.length < 4) {
    return false;
  }

  const firstFour = nineFigStr.substring(0, 4);
  const nineFigNumber = parseInt(firstFour, 10);
  if (isNaN(nineFigNumber)) {
    return false;
  }

  return nineFigNumber >= 2000 && nineFigNumber <= 3999;
}

export const MARK_TYPE_OPTION_LIST = SURVEY_MARK_MARK_TYPES.map((markType) => ({
  mark_type: markType,
  mark_type_txt: markTypeDisplayName(markType),
}));
